<!--
 * @Author: wsx
 * @Date: 2022-01-14 11:01:30
 * @LastEditTime: 2022-01-25 11:32:33
 * @LastEditors: your name
 * @Description:区域管理
-->
<template>
  <el-container class="RegionManage">
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <div>
        <el-button type="primary" @click="addTo()">添加</el-button>
      </div>
      <component
        ref="componentRef"
        :is="'PlotTable'"
        :region="currentNode"
        @editOrgan="editOrgan"
      ></component>
    </el-card>
    <component
      v-model="dialogVisible"
      :is="'StreetForm'"
      :type="dialogStatus"
      :params="currentNode"
      :tabsVal="tabsVal"
      :from="from"
      @drawArea="drawAreaBtn"
      @getCoordinates="getCoordinates"
    ></component>
    <el-dialog
      v-model="quartersVisible"
      :title="
        '小区' +
        (dialogStatus === 1 ? '新增' : dialogStatus === 2 ? '编辑' : '详情')
      "
      top="5vh"
      width="40vw"
    >
      <quarters
        ref="formRef"
        v-model="quartersVisible"
        :params="currentNode"
        :type="dialogStatus"
        @getCoordinates="getCoordinates"
        @submit="submit"
      ></quarters>
    </el-dialog>
    <el-dialog
      v-model="mapVisible"
      :title="mapDialogTitle"
      top="5vh"
      width="70vw"
      @close="mapDialogClose"
    >
      <div class="map-box" v-if="mapVisible">
        <my-map
          ref="mapRef"
          :features="mapFeatures"
          @draw-area="drawArea"
          @click-map="clickMap"
        ></my-map>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <h-button @click="mapVisible = false">取消</h-button>
          <h-button @click="saveMapPoint">确定</h-button>
          <h-button v-if="mapFeatures === 'draw-area'" @click="redrawArea"
            >重新绘制</h-button
          >
        </span>
      </template>
    </el-dialog>
  </el-container>
</template>
<script >
import { defineComponent, nextTick, reactive, toRefs, watch, ref } from "vue";
import MyMap from "@/components/map/MyMap.vue";
import quarters from "./components/communityManagementC/quarters.vue";
import { getMenutree } from "@/api/system/region";
import _ from "lodash";
export default defineComponent({
  name: "RegionManage",
  components: {
    MyMap,
    quarters,
  },
  props: {},
  setup(props) {
    const state = reactive({
      dialogStatus: 1, // 弹框状态  1:添加；2:编辑；3:只读
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      treeForm: { type: 2 },
      filterText: "",
      coordinate: [],
      currentNode: {},
      dataSource: [],
      pointPath: [],
      point: [],
      dialogVisible: false,
      tabsVal: "1",
      disableds: false,
      mapVisible: false,
      quartersVisible: false,
      mapFeatures: "point-pick",
      mapDialogTitle: "获取坐标",
      types: ["street", "community", "grid", "plot", "build", "unit"],
      from: {},
      tabPaneSource: {
        1: {
          id: "0",
          title: "街道",
          component: "StreetTable",
        },
        2: {
          id: "1",
          title: "社区",
          component: "CommunityTable",
        },
        3: {
          id: "2",
          title: "网格",
          component: "GridTable",
        },
        4: {
          id: "3",
          title: "小区",
          component: "PlotTable",
        },
      },
      oldtable: {},
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const mapRef = ref(null);
    const formRef = ref(null);
    const componentRef = ref(null);
    // const socket = useContext('socket');
    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const res = await getMenutree(state.treeForm);
      state.dataSource = [res.data];
      if (res.data) {
        currentChange(res.data);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          treeRef.value.setCurrentKey(state.currentNode.id);
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.oldtable = state.tabPaneSource;
      const newtabPane = [];
      // const tabPane = _.cloneDeep(Object.values(state.tabPaneSource));
      const tabPaneSource = _.cloneDeep(state.oldtable);
      const tabPane = Object.values(tabPaneSource);
      if (item.type === "0") {
        state.tabsVal = "1";
        // tabPane = Object.values(tabPaneSource);
        state.oldtable = state.tabPaneSource;
        if (state.tabsVal === "1" && item.type === "0") {
          tabPane.forEach((item) => {
            if (item.id >= "1") {
              newtabPane.push(item);
            }
            state.oldtable = newtabPane;
          });
        }
      } else if (item.type === "1") {
        state.tabsVal = "2";
        state.oldtable = state.tabPaneSource;
        if (state.tabsVal === "2" && item.type === "1") {
          tabPane.forEach((item) => {
            if (item.id >= "2") {
              newtabPane.push(item);
            }
            state.oldtable = newtabPane;
          });
        }
      } else if (item.type === "2") {
        state.tabsVal = "3";
        state.oldtable = state.tabPaneSource;
        if (state.tabsVal === "3" && item.type === "2") {
          tabPane.forEach((item) => {
            if (item.id >= "3") {
              newtabPane.push(item);
            }
            state.oldtable = newtabPane;
          });
        }
      } else if (item.type === "3") {
        state.tabsVal = "4";
        state.oldtable = state.tabPaneSource;
        if (state.tabsVal === "4" && item.type === "3") {
          tabPane.forEach((item) => {
            if (item.id >= "4") {
              newtabPane.push(item);
            }
          });
          state.oldtable = newtabPane;
        }
      } else if (item.type === "root") {
        state.tabsVal = "0";
        state.oldtable = state.tabPaneSource;
      }
      state.currentNode = item;
      console.log("ididi item", state.oldtable, item);
      // state.tabPaneSource

      // nextTick(() => {
      //   tableRef.value && tableRef.value.refresh();
      // });
    };
    // 点击右侧tab数据切换
    const tabClick = (item) => {};
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    };
    queryOrganTreAsync();

    // 编辑
    const editOrgan = async (row) => {
      if (row) {
        // state.from = row;
        state.currentNode = row;
      }
      state.dialogStatus = 2;
      // resetForm(formRef.value);
      state.quartersVisible = true;
      // data.formInline = _.cloneDeep(data.currentNode);
    };
    // 点击地图
    const clickMap = (e, point) => {
      state.point = point;
      console.log(
        "%c [ point ]-247",
        "font-size:13px; background:pink; color:#bf2c9f;",
        point
      );
    };
    // 绘制区域回调
    const drawArea = (corrdinates) => {
      state.pointPath = corrdinates[0];
      console.log(
        "%c [ corrdinates ]-256",
        "font-size:13px; background:pink; color:#bf2c9f;",
        corrdinates
      );
    };
    // 重新绘制
    const redrawArea = () => {
      mapRef.value.redrawArea();
    };
    // 获取坐标按钮
    const getCoordinates = () => {
      state.mapDialogTitle = "获取坐标";
      state.mapFeatures = "point-pick";
      state.mapVisible = true;
    };
    // 绘制区域按钮
    const drawAreaBtn = () => {
      state.mapDialogTitle = "绘制区域";
      state.mapFeatures = "draw-area";
      state.mapVisible = true;
    };
    // 保存地图点位
    const saveMapPoint = () => {
      if (formRef.value) {
        if (state.mapFeatures === "draw-area") {
          // 绘制区域
          formRef.value.setPointPath(state.pointPath);
        } else if (state.mapFeatures === "point-pick") {
          // 获取点位
          formRef.value.setPoint(state.point);
        }
      }
      state.mapVisible = false;
    };
    // 地图弹框关闭回调
    const mapDialogClose = () => {
      mapRef.value && mapRef.value.resetMap();
    };
    // 添加弹框
    const addTo = () => {
      state.quartersVisible = true;
      state.dialogStatus = 1;
    };
    const submit = () => {
      console.log(componentRef, 666666);
      componentRef.value && componentRef.value.tableRef.refresh();
      state.quartersVisible = false;
    };
    return {
      ...refData,
      submit,
      addTo,
      treeRef,
      mapRef,
      formRef,
      currentChange,
      getCoordinates,
      mapDialogClose,
      filterNode,
      saveMapPoint,
      editOrgan,
      componentRef,
      clickMap,
      drawArea,
      redrawArea,
      drawAreaBtn,
      tabClick,
    };
  },
});
</script>
<style  lang='scss' scoped >
.RegionManage {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-btn {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
  }
  .map-box {
    width: 100%;
    height: 70vh;
  }
}
</style>
